import {MARKETS_LIST} from '~/central-scripts/central-const'

export const getMarketLang = (marketCode: string) => {
  if (!marketCode || marketCode === 'undefined') return 'en'
  return Object.values(MARKETS_LIST).reduce((acc, market: any) => {
    if (marketCode.includes(market.cms)) {
      acc = market.lang
    }
    return acc
  }, []) ?? 'en'
}
